'use client';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import type { SelectedEquipmentInfo } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { EQUIPMENT_IMAGE_PARAMS } from '../constants';
import { Image } from 'components/image';
import { getProductName } from '@cat-ecom/common/utils/stringUtils';
import { getFamilyName } from 'services/equipment/utils';

export const SelectEquipmentDrawerEquipmentInfo = ({
  currentEquipment,
  PCCLucidHeadlessMEQDrawerFlag
}: {
  currentEquipment: SelectedEquipmentInfo;
  PCCLucidHeadlessMEQDrawerFlag: boolean;
}) => {
  const imageParams = EQUIPMENT_IMAGE_PARAMS;

  const familyName = getFamilyName(
    currentEquipment.model,
    currentEquipment.name ?? currentEquipment.productFamily
  );

  const equipmentName = `${currentEquipment.model} ${getProductName(familyName ?? '')}`;

  const { assetId, assetName } = currentEquipment;

  return (
    <div className="d-flex mt-3 mb-3 pb-1">
      <Image
        className="mb-0 me-3"
        height={60}
        width={80}
        alt={`${currentEquipment.model} ${currentEquipment.productFamily}`}
        src={
          (currentEquipment.imageURL || currentEquipment.imageUrl) &&
          `${currentEquipment.imageURL || currentEquipment.imageUrl}${imageParams}`
        }
      />
      <div>
        <CatHeading variant="display-sm">
          <span className="text-truncate d-block" style={{ maxWidth: '216px' }}>
            {assetName || assetId}
          </span>
        </CatHeading>
        <CatHeading variant="body">
          {PCCLucidHeadlessMEQDrawerFlag
            ? getProductName(currentEquipment?.name)
            : equipmentName}
        </CatHeading>
        <CatHeading variant="body">{currentEquipment.serialNumber}</CatHeading>
      </div>
    </div>
  );
};
